interface ToastProps {
  /** Text shown next to the success checkmark. */
  message: string
}

/**
 * Small success toast pinned above the bottom action bar. Shares the visual
 * treatment used for the "Customer selected" confirmation so feedback stays
 * consistent across the customer hub.
 */
export default function Toast({ message }: ToastProps) {
  return (
    <div
      className="fixed bottom-[120px] left-0 right-0 z-100 mx-auto flex w-fit items-center justify-center rounded-[99px] bg-white px-[18px] py-[10px] shadow-[0px_4px_16px_0px_rgba(0,0,0,0.1)]"
      role="status"
      aria-live="polite"
      data-testid="toast"
    >
      <div className="mr-8 flex h-32 w-32 items-center justify-center rounded-full bg-[rgba(96,164,42,0.2)] text-[rgba(96,164,42,1)]">
        ✓
      </div>
      <span className="text-sm font-medium">{message}</span>
    </div>
  )
}
